/**
 * Hub Dashboard Constants
 * Extracted from HubDashboard.jsx
 */

import { 
  Home, Mail, MessageSquareLock, LayoutDashboard, UserCheck,
  ShieldCheck, Users, Briefcase, Shield, Coins, Sliders,
  BarChart3, Link2, Activity, Settings, Video, FileText,
  Truck, Wrench, ClipboardCheck, Calculator, Share2
} from 'lucide-react';

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Navigation items
export const NAV_ITEMS = [
  { path: '/hub', label: 'Hub', icon: Home, permission: null },
  { path: '/messages', label: 'Messages', icon: Mail, permission: null },
  { path: '/chat-permissions', label: 'Chat Perms', icon: MessageSquareLock, permission: 'master' },
  { path: '/dashboard', label: 'Dashboard', icon: LayoutDashboard, permission: 'admin' },
  { path: '/training', label: 'Driver Training', icon: Video, permission: 'admin' },
  { path: '/fleet', label: 'Fleet', icon: Truck, permission: 'admin' },
  { path: '/txt-conv', label: 'TXT Conv.', icon: FileText, permission: 'admin' },
  { path: '/approvals', label: 'Approvals', icon: UserCheck, permission: 'master' },
  { path: '/admin-control', label: 'Admin Control', icon: ShieldCheck, permission: 'master' },
  { path: '/users', label: 'Users', icon: Users, permission: 'admin' },
  { path: '/job-titles', label: 'Job Titles', icon: Briefcase, permission: 'master' },
  { path: '/roles', label: 'Roles', icon: Shield, permission: 'master' },
  { path: '/points', label: 'Points', icon: Coins, permission: 'admin' },
  { path: '/points-config', label: 'Points Config', icon: Sliders, permission: 'master' },
  { path: '/app-stats', label: 'App Stats', icon: BarChart3, permission: 'admin' },
  { path: '/apps', label: 'Connected Apps', icon: Link2, permission: 'master' },
  { path: '/events', label: 'Activity Log', icon: Activity, permission: 'admin' },
  { path: '/settings', label: 'Settings', icon: Settings, permission: null },
];

// Connected apps
export const APPS = [
  { id: 'ridero', name: 'Ridero', icon: Truck, color: '#22c55e', url: 'https://www.rideroexpress.com/' },
  { id: 'mechanic_kiosk', name: 'Kiosk', icon: Wrench, color: '#3b82f6', url: 'https://peoriakiosk.com/login' },
  { id: 'pti_pector', name: 'PTI', icon: ClipboardCheck, color: '#f97316', url: 'https://ptipector.com' },
  { id: 'mcanick_scout', name: 'Mcnk Ai', icon: Wrench, color: '#8B5CF6', url: 'https://ptipector.com/api/mcanick' },
  { id: 'mr_mathematico', name: 'Mr.Math', icon: Calculator, color: '#EC4899', url: 'https://www.mrmathematico.com/auth/callback' },
  { id: 'fleet_share', name: 'Fleet Share', icon: Share2, color: '#06B6D4', url: 'https://fleetshare.us/auth/callback' },
];

// Role-based app restrictions
export const ROLE_APP_RESTRICTIONS = {
  truck_driver: ['pti_pector'],
  ridero_driver: ['ridero'],
};

// Available widgets for dashboard
export const AVAILABLE_WIDGETS = [
  { type: 'ridero_orders', label: 'Ridero Orders', icon: Briefcase },
  { type: 'ridero_drivers', label: 'Ridero Drivers', icon: Truck },
  { type: 'ridero_daily_feed', label: 'Ridero Daily Feed', icon: Activity },
  { type: 'tasks', label: 'My Tasks', icon: ClipboardCheck },
  { type: 'trucks', label: 'Truck Status', icon: Truck },
  { type: 'stats', label: 'Quick Stats', icon: BarChart3 },
  { type: 'drivers', label: 'Driver Status', icon: Users },
  { type: 'safety', label: 'Safety Score', icon: Shield },
  { type: 'compliance', label: 'Compliance', icon: FileText },
  { type: 'badges', label: 'My Badges', icon: Shield },
  { type: 'streak', label: 'Login Streak', icon: Activity },
];

// Helper to filter apps based on user role AND connected_apps
export const getFilteredApps = (userRole, userConnectedApps = [], roleAllowedApps = []) => {
  // Master admin sees all apps
  if (userRole === 'master_admin' || userRole === 'admin') {
    return APPS;
  }
  
  // First check if role has allowed_apps defined
  if (roleAllowedApps && roleAllowedApps.length > 0) {
    return APPS.filter(app => roleAllowedApps.includes(app.id));
  }
  
  // Then check role-based restrictions
  const restrictions = ROLE_APP_RESTRICTIONS[userRole];
  if (restrictions) {
    return APPS.filter(app => restrictions.includes(app.id));
  }
  
  // Finally check connected_apps
  if (userConnectedApps && userConnectedApps.length > 0) {
    return APPS.filter(app => userConnectedApps.includes(app.id));
  }
  
  // No connected apps = show no apps (except for master_admin)
  return [];
};

// Default widget layout
export const DEFAULT_WIDGETS = [
  { id: 'w1', type: 'ridero_orders' },
  { id: 'w2', type: 'ridero_drivers' },
  { id: 'w9', type: 'ridero_daily_feed' },
  { id: 'w3', type: 'tasks' },
  { id: 'w4', type: 'trucks' },
  { id: 'w5', type: 'stats' },
  { id: 'w6', type: 'drivers' },
  { id: 'w7', type: 'badges' },
  { id: 'w8', type: 'streak' },
];

// Mobile navigation tabs
export const MOBILE_TABS = [
  { tab: 'home', label: 'Hub', icon: Home, color: '#FFD700' },
  { tab: 'kudos', label: 'Kudos', icon: Users, color: '#22C55E' },
  { tab: 'teams', label: 'Teams', icon: Users, color: '#3B82F6' },
  { tab: 'calendar', label: 'Calendar', icon: Activity, color: '#8B5CF6' },
  { tab: 'documents', label: 'Docs', icon: FileText, color: '#F97316' },
];
